import CardTargetAudiences from './CardTargetAudiences';
import './CardTargetAudiences.scss';

export default CardTargetAudiences;
